import { List } from "@mui/material";

import CallLogItem from "./CallLogItem";

export default function CallLogList({ callLogList = [] }) {
  const style = {
    outer: "text-sm py-0 px-0",
    inner: "text-black w-full flex bg-white border-gray-100 border-y items-center py-0",
    column1: "w-[10%] text-left align-middle ",
    column2: "w-[19%] text-left ",
    column3: "w-[19%] text-left align-middle ",
    column4: "w-[15%] text-center align-middle ",
    column5: "w-[17%] text-center align-middle ",
    column6: "w-[19%] text-center align-middle ",
    header: "text-xs uppercase font-bold py-3 align-middle ",
  };

  return (
    <div className="list-container">
      <div className={style.outer}>
        <div className={style.inner}>
          <div className={style.column1 + style.header}>Dir.</div>
          <div className={style.column2 + style.header + "text-left"}>Caller</div>
          <div className={style.column3 + style.header}>Receiver</div>
          <div className={style.column4 + style.header}>Start Date/Time</div>
          <div className={style.column5 + style.header}>Duration</div>
          <div className={style.column6 + style.header}>Outcome</div>
        </div>
      </div>
      {callLogList?.length === 0 ? (
        <div className="my-2 text-center" data-testid="no-items">
          No Logs to Show
        </div>
      ) : (
        <List className="max-h-[58.5vh] overflow-y-auto border-y border-gray-200">
          <div className="items-list">
            {callLogList.map((log) => (
              <CallLogItem key={log.id} log={log} style={style} />
            ))}
          </div>
        </List>
      )}
    </div>
  );
}
